import React from 'react'
import clsx from 'clsx'

export interface SubTabOption<T extends string = string> {
  key: T
  title: string
  icon?: string
}

interface SubTabHeaderProps<T extends string = string> {
  tab: string
  setTab: (tab: string) => void
  tabs: SubTabOption<T>[]
}

const SubTabHeader: React.FC<SubTabHeaderProps> = ({tab, setTab, tabs}) => {
  return (
    <div className='d-flex flex-row flex-nowrap justify-content-start align-items-center gap-2 mb-5'>
      {tabs.map((t) => (
        <button
          type="button" 
          key={t.key}
          className={clsx('btn btn-sm btn-light', tab === t.key && 'btn-primary')}
          onClick={() => setTab(t.key)}
        >
          {t.icon && <i className={`${t.icon} me-2`}></i>}
          {t.title}
        </button>
      ))}
    </div>
  )
}

export default SubTabHeader
